import update from 'immutability-helper';

import {
  ActionsOfTabState,
  TabStateProps,
  ImageElementType,
  Tabs,
  RichTextElement,
} from './TabStateInterfaces';

const initialTabState = {
  tabs: {
    1: {
      tabId: 1,
      tabName: 'Tab - 1',
      showDash: false,
      //   dashMode: 'Edit',
      hidden: false,
      dashLayout: {
        dashboardLayout: 'Auto',
        selectedOptionForAuto: 'Full Screen',
        aspectRatio: { height: 9, width: 16 },
        selectedOptionForFixed: 'HD',
        custom: { height: 9, width: 16 },
        customRange: {
          minHeight: 9,
          minWidth: 16,
          maxHeight: 12,
          maxWidth: 24,
        },
      },

      // properties specific to tiles within this tab
      selectedTileName: 'Tile - 1',
      selectedTileId: 1,
      nextTileId: 2,
      tilesInDashboard: [],
      hoveredItems: [],
      hoveredPropkey: '',
      dashTilesDetails: {},
      resolutionSettings: {
        // Resolution settings for the dashboard
        dashboardHeight: 0,
        resolutionType: 'autoWidth',
        resolution: '',
        autoScalingWidth: '',
        autoScalingHeight: '',
        dashboardRows: 32,
      },
      dashboardState: {
        theme: 'FlatUI',
        colorScheme: '',
        themeId: '',
        allTabs: false,
        allTiles: false,
        themeState: false,
        defaultThemeId: '',
        fontFamily: "'Roboto', sans-serif",
        tilesTodashboard: false,
        fontFamilyForAllTiles: false,
        filterVisibilityMode: 'present',
        filterPanelMode: 'collapse',
        isCustomLayout: false,
      },
      dashboardObjects: {
        imageElements: [],
        selectedImageId: null,
        richTextElements: [],
        richTextElementId: null,
      },
      allTileBorder: {
        isBorder: true,
        borderProperties: { color: '#cecece', width: 1, borderRadius: 2 },
      },
      interactivity: {
        mouseOverInteractivity: false,
      },
    },
  },
  tabList: [1],
  hoveredTileKey: null,
  selectedTileKey: null,
};

const tabStateReducer = (state: TabStateProps = initialTabState, action: ActionsOfTabState) => {
  switch (action.type) {
    case 'SET_THEME':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              theme: { $set: action.payload.theme },
            },
          },
        },
      });

    case 'SET_THEME_ID': {
      const { themeId, tabId } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardState: {
              themeId: { $set: themeId },
            },
          },
        },
      });
    }

    case 'SET_DEFAULT_THEME_ID': {
      const { tabId, themeId } = action.payload;
      return {
        ...state,
        tabs: {
          ...state.tabs,
          [tabId]: {
            ...state.tabs[tabId],
            dashboardState: {
              ...state.tabs[tabId].dashboardState,
              defaultThemeId: themeId,
            },
          },
        },
      };
    }

    case 'TOGGLE_THEME_STATE':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              themeState: {
                $set: !state.tabs[action.payload.tabId].dashboardState.themeState,
              },
            },
          },
        },
      });

    case 'SET_COLOR_SCHEME':
      const payload = action.payload || {};
      const tabId = payload.tabId || '1';
      const colorScheme = payload.colorScheme || 'peacock';
      console.log(action.payload.colorScheme);
      // return update(state, { tabs:{
      // [tabId]:{
      // 	dashboardState:{
      // 		colorScheme:{$set:colorScheme}
      // 	}
      // }
      // }, }, );
      return {
        ...state,
        tabs: {
          ...state.tabs,
          [tabId]: {
            ...state.tabs[tabId],
            dashboardState: {
              ...state.tabs[tabId].dashboardState,

              colorScheme: colorScheme,
            },
          },
        },
      };

    case 'TOGGLE_ALL_TABS':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              allTabs: {
                $set: !state.tabs[action.payload.tabId].dashboardState.allTabs,
              },
            },
          },
        },
      });

    case 'TOGGLE_ALL_TILES':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              allTiles: {
                $set: !state.tabs[action.payload.tabId].dashboardState.allTiles,
              },
            },
          },
        },
      });

    case 'SET_HOVERED_TILE':
      return {
        ...state,
        hoveredTileKey: action.payload,
      };

    case 'CLEAR_HOVERED_TILE':
      return {
        ...state,
        hoveredTileKey: null,
      };
    case 'SET_SELECTED_TILE':
      if (state.selectedTileKey === action.payload) {
        return { ...state, selectedTileKey: null };
      }
      return { ...state, selectedTileKey: action.payload };

    case 'SET_ALL_TILE_BORDER': {
      const { tabId, borderProperties } = action.payload;

      return {
        ...state,
        tabs: {
          ...state.tabs,
          [tabId]: {
            ...state.tabs[tabId],
            allTileBorder: {
              isBorder: true,
              borderProperties: borderProperties,
            },
          },
        },
      };
    }

    case 'UPDATE_ALL_TILE_BORDER': {
      const { tabId, borderProperties } = action.payload;

      return {
        ...state,
        tabs: {
          ...state.tabs,
          [tabId]: {
            ...state.tabs[tabId],
            allTileBorder: {
              isBorder: true,
              borderProperties: borderProperties,
            },
          },
        },
      };
    }

    case 'REMOVE_ALL_TILE_BORDER': {
      const { tabId } = action.payload;

      return {
        ...state,
        tabs: {
          ...state.tabs,
          [tabId]: {
            ...state.tabs[tabId],
            allTileBorder: {
              isBorder: false,
              borderProperties: state.tabs[tabId]?.allTileBorder?.borderProperties ?? null,
            },
          },
        },
      };
    }

    case 'TOGGLE_MOUSEOVER_INTERACTIVITY': {
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            interactivity: {
              $apply: (interactivity = { mouseOverInteractivity: false }) => ({
                ...interactivity,
                mouseOverInteractivity: !interactivity?.mouseOverInteractivity,
              }),
            },
          },
        },
      });
    }

    // ==================================================================

    // Resolution related actions

    case 'SET_RESOLUTION_TYPE':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            resolutionSettings: {
              resolutionType: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SET_RESOLUTION':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            resolutionSettings: {
              resolution: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SET_AUTO_SCALING_WIDTH':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            resolutionSettings: {
              autoScalingWidth: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SET_AUTO_SCALING_HEIGHT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            resolutionSettings: {
              autoScalingHeight: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SET_DASHBOARD_HEIGHT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            resolutionSettings: {
              dashboardHeight: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SET_DASHBOARD_ROWS':
      if (!state.tabs[action.payload.tabId]) {
        return state;
      }
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            resolutionSettings: {
              dashboardRows: { $set: action.payload.value },
            },
          },
        },
      });

    // Image Elements

    case 'ADD_IMAGE_ELEMENT': {
      const { tabId, newElement } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              imageElements: {
                $push: [newElement],
              },
            },
          },
        },
      });
    }

    case 'SET_SELECTED_IMAGE_ID': {
      const { tabId, selectedImageId } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              selectedImageId: { $set: selectedImageId },
            },
          },
        },
      });
    }

    case 'SET_IMAGE_ELEMENTS': {
      const { tabId, imageElements } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              imageElements: { $set: imageElements },
            },
          },
        },
      });
    }

    case 'UPDATE_IMAGE_ELEMENT': {
      const { tabId, id, updates } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              imageElements: {
                $apply: (elements: ImageElementType[]) =>
                  elements.map((el) => (el.id === id ? { ...el, ...updates } : el)),
              },
            },
          },
        },
      });
    }

    case 'REMOVE_IMAGE_ELEMENT': {
      const { tabId, id } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              imageElements: {
                $apply: (elements: ImageElementType[]) => elements.filter((el) => el.id !== id),
              },
            },
          },
        },
      });
    }

    case 'UPDATE_IMAGE_POSITION': {
      const { tabId, id, x, y, isAutoReflow } = action.payload;
      const updateObj: any = {
        dashboardObjects: {
          imageElements: {
            $apply: (elements: ImageElementType[]) =>
              elements.map((el) => (el.id === id ? { ...el, x, y } : el)),
          },
        },
      };

      if (!isAutoReflow) {
        updateObj.dashboardState = {
          isCustomLayout: { $set: true },
        };
      }

      return update(state, {
        tabs: {
          [tabId]: updateObj,
        },
      });
    }

    case 'UPDATE_IMAGE_SIZE': {
      const { tabId, id, width, height, x, y, isAutoReflow } = action.payload;
      const updateObj: any = {
        dashboardObjects: {
          imageElements: {
            $apply: (elements: ImageElementType[]) =>
              elements.map((el) => (el.id === id ? { ...el, width, height, x, y } : el)),
          },
        },
      };

      if (!isAutoReflow) {
        updateObj.dashboardState = {
          isCustomLayout: { $set: true },
        };
      }

      return update(state, {
        tabs: {
          [tabId]: updateObj,
        },
      });
    }

    case 'ADD_RICH_TEXT_ELEMENT': {
      const { tabId, newElement } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              richTextElements: {
                $push: [newElement],
              },
            },
          },
        },
      });
    }

    case 'REMOVE_RICH_TEXT_ELEMENT': {
      const { tabId, id } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              richTextElements: {
                $apply: (elements: RichTextElement[]) => elements.filter((el) => el.id !== id),
              },
            },
          },
        },
      });
    }

    case 'UPDATE_RICH_TEXT_POSITION': {
      const { tabId, id, x, y, isAutoReflow } = action.payload;
      const updateObj: any = {
        dashboardObjects: {
          richTextElements: {
            $apply: (elements: RichTextElement[]) =>
              elements.map((el) => (el.id === id ? { ...el, x, y } : el)),
          },
        },
      };

      if (!isAutoReflow) {
        updateObj.dashboardState = {
          isCustomLayout: { $set: true },
        };
      }

      return update(state, {
        tabs: {
          [tabId]: updateObj,
        },
      });
    }

    case 'UPDATE_RICH_TEXT_SIZE': {
      const { tabId, id, width, height, x, y, isAutoReflow } = action.payload;
      const updateObj: any = {
        dashboardObjects: {
          richTextElements: {
            $apply: (elements: RichTextElement[]) =>
              elements.map((el) => (el.id === id ? { ...el, width, height, x, y } : el)),
          },
        },
      };

      if (!isAutoReflow) {
        updateObj.dashboardState = {
          isCustomLayout: { $set: true },
        };
      }

      return update(state, {
        tabs: {
          [tabId]: updateObj,
        },
      });
    }

    case 'UPDATE_RICH_TEXT_ELEMENT': {
      const { tabId, id, updates } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              richTextElements: {
                $apply: (elements: RichTextElement[]) =>
                  elements.map((el) => (el.id === id ? { ...el, ...updates } : el)),
              },
            },
          },
        },
      });
    }

    case 'SET_SELECTED_RICH_TEXT_ID': {
      const { tabId, selectedRichTextId } = action.payload;
      return update(state, {
        tabs: {
          [tabId]: {
            dashboardObjects: {
              richTextElementId: { $set: selectedRichTextId },
            },
          },
        },
      });
    }

    case 'SET_FONT_FAMILY':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              fontFamily: { $set: action.payload.fontFamily },
            },
          },
        },
      });

    case 'SET_FONT_FAMILY_FOR_ALL_TILES':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              fontFamilyForAllTiles: { $set: action.payload.fontFamilyForAllTiles },
            },
          },
        },
      });

    case 'SET_TILES_COLOR_SCHEME_TO_DASHBOARD_SCHEME':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              tilesTodashboard: { $set: action.payload.tilesTodashboard },
            },
          },
        },
      });

    //filter related reducers

    case 'SET_FILTER_VISIBILITY_MODE':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              filterVisibilityMode: { $set: action.payload.filterVisibilityMode },
            },
          },
        },
      });

    case 'SET_FILTER_PANEL_MODE':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              filterPanelMode: { $set: action.payload.filterPanelMode },
            },
          },
        },
      });

    case 'RESET_CUSTOM_LAYOUT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashboardState: {
              isCustomLayout: { $set: false },
            },
          },
        },
      });

    // ==================================================================
    // Tab Properties
    // ==================================================================

    case 'ADD_TAB':
      return {
        tabList: [...state.tabList, action.payload.tabId],
        tabs: {
          ...state.tabs,
          [action.payload.tabId]: {
            tabId: action.payload.tabId,
            tabName: action.payload.tabName || `Tab - ${action.payload.tabId}`,
            showDash: false,
            //  dashMode: 'Edit',
            hidden: false,
            dashLayout: {
              dashboardLayout: 'Auto',
              selectedOptionForAuto: 'Full Screen',
              aspectRatio: { height: 9, width: 16 },
              selectedOptionForFixed: 'HD',
              custom: { height: 9, width: 16 },
              customRange: {
                minHeight: 9,
                minWidth: 16,
                maxHeight: 12,
                maxWidth: 24,
              },
            },

            // properties specific to tiles within this tab
            selectedTileName: 'Tile - 1',
            selectedTileId: 1,
            nextTileId: 2,
            tilesInDashboard: [],
            hoveredItems: [],
            hoveredPropkey: '',
            dashTilesDetails: {},
            resolutionSettings: {
              dashboardHeight: 0,
              resolutionType: 'autoWidth',
              resolution: '',
              autoScalingWidth: '',
              autoScalingHeight: '',
              dashboardRows: 32,
            },
            dashboardState: {
              theme: 'FlatUI',
              colorScheme: '',
              themeId: '',
              allTabs: false,
              allTiles: false,
              themeState: false,
              filterVisibilityMode: 'present',
              filterPanelMode: 'collapse',
              tilesTodashboard: false,
              fontFamily: "'Roboto', sans-serif",
              fontFamilyForAllTiles: false,
              isCustomLayout: false,
            },
            dashboardObjects: {
              imageElements: [],
              selectedImageId: null,
              richTextElements: [],
              richTextElementId: null,
            },
            allTileBorder: {
              isBorder: true,
              borderProperties: { color: '#cecece', width: 1, borderRadius: 2 },
            },
            interactivity: {
              mouseOverInteractivity: false,
            },
          },
        },
      };
    case 'TOGGLE_TAB_HIDDEN':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            hidden: {
              $apply: (hidden) => !hidden,
            },
          },
        },
      });

    case 'REMOVE_TAB':
      return update(state, {
        tabs: { $unset: [action.payload.tabId] },
        tabList: { $splice: [[action.payload.tabToRemoveIndex, 1]] },
      });

    case 'RENAME_TAB':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            tabName: { $set: action.payload.renameValue },
          },
        },
      });

    // ==================================================================
    // Tile Properties
    // ==================================================================

    case 'UPDATE_NEXT_TILE_ID':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            nextTileId: { $set: action.payload.nextTileId + 1 },
          },
        },
      });

    case 'SELECTED_TILE_IN_TAB':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            selectedTileName: { $set: action.payload.tileName },
            selectedTileId: { $set: action.payload.tileId },
          },
        },
      });

    case 'SHOW_DASHBOARD_IN_TAB':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            showDash: { $set: action.payload.showDash },
          },
        },
      });

    // case 'TOGGLE_DASH_MODE_IN_TAB':
    //   return update(state, {
    //     tabs: {
    //       [action.payload.tabId]: {
    //         dashMode: { $set: action.payload.dashMode },
    //       },
    //     },
    //   });

    case 'UPDATE_DASH_GRAPH_DETAILS':
      if (action.payload.checked) {
        return update(state, {
          tabs: {
            [action.payload.tabId]: {
              tilesInDashboard: { $splice: [[action.payload.propIndex, 1]] },
              dashTilesDetails: { $unset: [action.payload.propKey] },
            },
          },
        });
      } else {
        return update(state, {
          tabs: {
            [action.payload.tabId]: {
              tilesInDashboard: { $push: [action.payload.propKey] },
              dashTilesDetails: {
                [action.payload.propKey]: { $set: action.payload.dashSpecs },
              },
            },
          },
        });
      }

    case 'REMOVE_TILES_IN_DASH_DURING_DELETE_TILE':
      var dashTilesDetailsCopy = Object.assign(state.tabs[action.payload.tabId].dashTilesDetails);

      var tilesInDashboardCopy = Object.assign(state.tabs[action.payload.tabId].tilesInDashboard);

      tilesInDashboardCopy = tilesInDashboardCopy.filter(
        (propKey: string) => propKey !== action.payload.propKey,
      );

      delete dashTilesDetailsCopy[action.payload.propKey];

      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashTilesDetails: { $set: dashTilesDetailsCopy },
            tilesInDashboard: { $set: tilesInDashboardCopy },
          },
        },
      });

    case 'UPDATE_DASH_GRAPH_POSITION':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashTilesDetails: {
              [action.payload.propKey]: {
                x: { $set: action.payload.x },
                y: { $set: action.payload.y },
              },
            },
            dashboardState: {
              isCustomLayout: { $set: true },
            },
          },
        },
      });

    case 'UPDATE_DASH_GRAPH_SIZE': {
      const updateObj: any = {
        dashTilesDetails: {
          [action.payload.propKey]: {
            x: { $set: action.payload.x },
            y: { $set: action.payload.y },
            width: { $set: action.payload.width },
            height: { $set: action.payload.height },
          },
        },
      };

      if (!action.payload.isAutoReflow) {
        updateObj.dashboardState = {
          isCustomLayout: { $set: true },
        };
      }

      return update(state, {
        tabs: {
          [action.payload.tabId]: updateObj,
        },
      });
    }

    case 'UPDATE_HOVERED_ITEMS':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            hoveredItems: { $set: action.payload.colItems },
            hoveredPropkey: { $set: action.payload.propKey },
          },
        },
      });

    case 'SET_GRAPH_BORDER_HIGHLIGHT':
      var copyOfDetails = state.tabs[action.payload.tabId].dashTilesDetails;
      var items = Object.keys(copyOfDetails);

      items.forEach((item) => {
        if (item === action.payload.propKey) {
          copyOfDetails[item].highlight = true;
        } else {
          copyOfDetails[item].highlight = false;
        }
      });

      return update(state, {
        tabs: {
          [action.payload.tabId]: { dashTilesDetails: { $set: copyOfDetails } },
        },
      });

    case 'RESET_GRAPH_BORDER_HIGHLIGHT':
      var copyOfDetails: any = state.tabs[action.payload].dashTilesDetails;
      var items = Object.keys(copyOfDetails);

      items.forEach((item) => {
        copyOfDetails[item].highlight = false;
      });

      return update(state, {
        tabs: {
          [action.payload]: { dashTilesDetails: { $set: copyOfDetails } },
        },
      });
    case 'SET_DASHLAYOUT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              dashboardLayout: { $set: action.payload.value },
            },
          },
        },
      });
    case 'SET_DASHLAYOUT_SELECTEDOPTION_FOR_AUTO':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              selectedOptionForAuto: { $set: action.payload.value },
              // selectedOptionForFixed: { $set: "" },
            },
          },
        },
      });
    case 'SET_ASPECTRATIO_HEIGHT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              aspectRatio: { height: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_ASPECTRATIO_WIDTH':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              aspectRatio: { width: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_CUSTOM_HEIGHT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              custom: { height: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_CUSTOM_WIDTH':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              custom: { width: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_CR_MAX_WIDTH':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              customRange: { maxWidth: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_CR_MIN_WIDTH':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              customRange: { minWidth: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_CR_MAX_HEIGHT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              customRange: { maxHeight: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_CR_MIN_HEIGHT':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              customRange: { minHeight: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'SET_DASHLAYOUT_SELECTEDOPTION_FOR_FIXED':
      return update(state, {
        tabs: {
          [action.payload.tabId]: {
            dashLayout: {
              selectedOptionForFixed: { $set: action.payload.value },
              // selectedOptionForAuto: { $set: "" },
            },
          },
        },
      });

    case 'LOAD_TAB_STATE_FROM_PLAYBOOK': {
      const updatedTabs: Tabs = {};

      for (const tabId in action.payload.tabs) {
        const tab = action.payload.tabs[tabId];

        updatedTabs[tabId] = {
          ...tab,
          resolutionSettings: {
            dashboardHeight: tab.resolutionSettings?.dashboardHeight ?? null,
            resolutionType: tab.resolutionSettings?.resolutionType ?? 'autoWidth',
            resolution: tab.resolutionSettings?.resolution ?? '',
            autoScalingWidth: tab.resolutionSettings?.autoScalingWidth ?? '',
            autoScalingHeight: tab.resolutionSettings?.autoScalingHeight ?? '',
            dashboardRows: tab.resolutionSettings?.dashboardRows ?? 32,
          },
          dashboardObjects: {
            imageElements: tab.dashboardObjects?.imageElements ?? [],
            selectedImageId: tab.dashboardObjects?.selectedImageId ?? null,
            richTextElements: tab.dashboardObjects?.richTextElements ?? [],
            richTextElementId: tab.dashboardObjects?.richTextElementId ?? null,
          },
          dashboardState: {
            fontFamily: tab.dashboardState?.fontFamily ?? "'Roboto', sans-serif",
            fontFamilyForAllTiles: tab.dashboardState?.fontFamilyForAllTiles ?? false,
            tilesTodashboard: tab.dashboardState?.tilesTodashboard ?? false,
            theme: tab.dashboardState?.theme ?? 'FlatUI',
            colorScheme: tab.dashboardState?.colorScheme ?? 'peacock',
            themeId: tab.dashboardState?.themeId ?? '',
            allTabs: tab.dashboardState?.allTabs ?? false,
            allTiles: tab.dashboardState?.allTiles ?? false,
            themeState: tab.dashboardState?.themeState ?? false,
            filterVisibilityMode: tab.dashboardState?.filterVisibilityMode ?? 'present',
            filterPanelMode: tab.dashboardState?.filterPanelMode ?? 'collapse',
          },
        };
      }

      return {
        ...action.payload,
        tabs: updatedTabs,
      };
    }

    case 'REORDER_TAB':
      const { moveAction, tabIndex } = action.payload;
      let currentTabList = state.tabList ? [...state.tabList] : [];
      switch (moveAction) {
        case 'left':
          if (tabIndex > 0) {
            const temp = currentTabList[tabIndex - 1];
            currentTabList[tabIndex - 1] = currentTabList[tabIndex];
            currentTabList[tabIndex] = temp;
          }
          break;

        case 'right':
          if (tabIndex < currentTabList.length - 1) {
            const temp = currentTabList[tabIndex + 1];
            currentTabList[tabIndex + 1] = currentTabList[tabIndex];
            currentTabList[tabIndex] = temp;
          }
          break;

        case 'first':
          const moveToFirst = currentTabList.splice(tabIndex, 1)[0];
          currentTabList.unshift(moveToFirst);
          break;

        case 'last':
          const moveToLast = currentTabList.splice(tabIndex, 1)[0];
          currentTabList.push(moveToLast);
          break;
      }
      return {
        ...state,
        tabList: currentTabList,
      };

    case 'RESET_TAB_STATE':
      return initialTabState;

    default:
      return state;
  }
};

export default tabStateReducer;
